import { gql } from '@apollo/client';

export const FETCH_ENROLLMENT_OPTIONS = gql`
  query Flex_FetchEnrollmentOptions($utilityId: Int!) {
    enrollmentOptions(utilityId: $utilityId) {
      id
      name
    }
  }
`;
